// Libs
import React from 'react';
import { Layout, Result } from 'antd';
import NackleMenu from '@nackle/menu';
const { Content } = Layout;
import { connect } from 'react-redux';

// Routing
import { Route, Link, routeHistory } from '@nackle/biw-web-router';
import { routes, bundleRoutingMiddleware } from './app-routing.jsx';

// Bridge
import { Bridge } from '@nackle/bridge';
import auth, { authRouteMiddleware, authRequestMiddleware, hasPermission } from './app-auth.js';

// Fetch
import { applyRequestMiddleware } from './utils/fetch';

// Components
import { AppHeader, AppFooter, AppError } from '@nackle/studio-tools';

// Services
import { CMXService } from '@nackle/studio-tools';
import { setLanguageBundle } from '@nackle/intl-tools';

import './styles/app.less';

/*******************************************************************************
 *	1. App (root level component)
 */
class App extends React.Component {
    state = {
        loaded: false,
        cmxBundleLoaded: false
    };
    handleCompanyChange = ( company ) => {
        const pathParts = window.location.pathname.split( '/' );
        if ( pathParts && pathParts.length > 0 ) {
            //get rid of empty first element
            pathParts.shift();
            //get rid of companyId
            pathParts.shift();
            if ( pathParts.length > 0 && pathParts[ 0 ] !== 'person-detail' ) {
                routeHistory.push( `/${ company.id }/${ pathParts[ 0 ] }` ); // don't push to a path with company specific uuid
            } else {
                routeHistory.push( `/${ company.id }/person-search` );
            }
        } else {
            routeHistory.push( `/${ company.id }/person-search` );
        }
    };

    render() {
        const { loaded, cmxBundleLoaded } = this.state;
        return (
            <AppError>
                <Route render={ ( route ) => {
                    // set the title
                    document.title = route && route.match ? route.match.title : 'Home';
                    // get the companyId from the route
                    const companyId = route.state?.params?.companyId;
                    // permissions
                    // const hasPermissions = ( permissions && permissions.length > 0 );
                    const permissionToView = route.match && ( route.match.permission ? hasPermission( route.match.permission ) : true );
                    return (
                        <Bridge
                            auth={ auth }
                            onSignIn={ this.handleSignIn }
                        >
                            {
                                loaded && (
                                    <Layout className="root-layout roster-root">
                                        <AppHeader
                                            companyId={ companyId }
                                            auth={ auth }
                                            onCompanyChange={ this.handleCompanyChange }
                                        />
                                        <Layout>
                                            <NackleMenu
                                                auth={ auth }
                                                cmxBundleLoaded={ cmxBundleLoaded }
                                            />
                                            <Layout className="page-layout">
                                                <Content className="app-content">
                                                    {
                                                        route.match && permissionToView ?
                                                            React.cloneElement( route.component, { companyId, auth, permissionToView } )
                                                            : route.match && !permissionToView ? (
                                                                <Result
                                                                    status="403"
                                                                    title="Access Denied"
                                                                    subTitle="Sorry, you do not have permissions for the page you visited."
                                                                    extra={ <Link to="/" className="ant-btn ant-btn-primary">Back Home</Link> }
                                                                />
                                                            ) : (
                                                                <Result
                                                                    status="404"
                                                                    title="404"
                                                                    subTitle="Sorry, the page you visited does not exist."
                                                                    extra={ <Link to="/" className="ant-btn ant-btn-primary">Back Home</Link> }
                                                                />
                                                            )
                                                    }
                                                </Content>
                                                <AppFooter />
                                            </Layout>
                                        </Layout>
                                    </Layout>
                                )
                            }
                        </Bridge>
                    );
                } } />
            </AppError>
        );
    }

    handleSignIn = async ( state ) => {
        await routeHistory.refresh();

        const cmxService = new CMXService( auth.state );
        const bundle = await cmxService.getBundle( [ 'navigation', 'studio-in-context-help' ] );
        const locale = auth.state.claims.locale;
        await setLanguageBundle( locale, bundle );

        this.setState( {
            loaded: true,
            cmxBundleLoaded: true,
        } );
    };
}

/*******************************************************************************
 *  2. Connect Routing
 */
routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( [ authRouteMiddleware, bundleRoutingMiddleware ] );

App = connect(
    // mapStateToProps
    ( state ) => {
        return {};
    },
    // mapDispatchToProps
    {
    }
)( App );

/*******************************************************************************
 *  3. Connect Auth to Fetch
 */
applyRequestMiddleware( authRequestMiddleware );

export default App;